import { Component, Vue } from "vue-property-decorator";
import { BASE_API_URL } from "../../utils/Constants";

export const POST_AUDIENCE_DATABASE = "post_audience_database";
export const GET_FILE_UPLOADS = "get_file_uploads";

@Component
export default class SettingsMixin extends Vue {
  readonly path = BASE_API_URL + "admin/";

  uploadAudienceDatabase(payload: any) {
    return this.$httpPost(
      this.path + "medium_audiences/upload",
      POST_AUDIENCE_DATABASE,
      payload
    );
  }

  getFileUploads() {
    return this.$httpGet(
      this.path + "file_uploads?filter[kind]=media",
      GET_FILE_UPLOADS
    );
  }
}
